import { SSMClient, GetParameterCommand } from '@aws-sdk/client-ssm';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Blocks third-party Chrome extension overlays from rendering on the application.
 * Known selectors are removed immediately. Additional selectors are fetched from SSM
 * parameter `/das-finsuite/fe/blocked-extension-selectors` (comma-separated) after auth.
 */

const HARDCODED_BLOCKED_SELECTORS = ['#amazon-quick-browser-extension-fab'];

const removeElements = (selectors: string[]): void => {
  selectors.forEach((sel) => document.querySelectorAll(sel.trim()).forEach((el) => el.remove()));
};

const fetchRemoteSelectors = async (): Promise<string[]> => {
  try {
    const session = await fetchAuthSession();
    const client = new SSMClient({ region: 'us-west-2', credentials: session.credentials });
    const { Parameter } = await client.send(new GetParameterCommand({ Name: '/das-finsuite/fe/blocked-extension-selectors' }));
    return (Parameter?.Value || '').split(',').filter(Boolean);
  } catch {
    return [];
  }
};

let observer: MutationObserver | null = null;

export const initExtensionBlocker = (): void => {
  // Immediate: remove known extensions
  removeElements(HARDCODED_BLOCKED_SELECTORS);
  observer = new MutationObserver(() => removeElements(HARDCODED_BLOCKED_SELECTORS));
  observer.observe(document.body, { childList: true, subtree: true });

  // Deferred: merge SSM selectors after auth is ready
  window.addEventListener('load', () =>
    setTimeout(async () => {
      const ssmSelectors = await fetchRemoteSelectors();
      const allSelectors = [...new Set([...HARDCODED_BLOCKED_SELECTORS, ...ssmSelectors])];
      removeElements(allSelectors);
      observer?.disconnect();
      observer = new MutationObserver(() => removeElements(allSelectors));
      observer.observe(document.body, { childList: true, subtree: true });
    }, 2000)
  );
};
